import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid, 
  Paper,
  Button,
} from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { Link as ReactRouter } from "react-router-dom";
import Appbar from "./../Appbar";
import GetStores from "./GetStores";
import * as paths from "./../../../Routes/paths";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  main: {
    flex: 1,
    padding: theme.spacing(6, 4),
    background: '#eaeff1',
    minHeight: "100vh",
  },
  paper: {
    maxWidth: 1000,
    margin: 'auto',
    overflow: 'hidden',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
}));


const Stores = () => {
	const classes = useStyles();
	return(
		<div className={classes.root}>
      <Appbar title="Products"/>
      <main className={classes.main}>
      <Grid container>
        <Grid item xs sm={2}/>
        <Grid item sm={10}>
          <Paper className={classes.paper}>
          	<Grid container>
          		<Grid item  sm={10}/>
          		<Grid item>
          			<Button 
          			variant="outlined" 
          			component={ReactRouter} 
          			to={paths.ADD_STORE_AGENTS} 
          			color="primary" 
          			startIcon={<AddIcon />}>
          			Add Store
          		</Button>
          		</Grid>
          	</Grid>
            <GetStores />
          </Paper>
        </Grid>
      </Grid>
      </main>
    </div>
	)
}

export default Stores